import { WorkflowEditCodeContext } from "@/components/automations/AutomationEditCodeContext";
import { WorkflowEditTriggerPullRequest } from "@/components/automations/PullRequestTriggerConfig";
import { type WorkflowEditFormTriggerData } from "@/components/automations/automation-edit-form-data";
import type { FC } from "react";
import type { PlainWorkflow } from "@/queries/automation-queries";

export type WorkflowEditTriggerConfigurationProps = {
    workflow: PlainWorkflow;
    trigger: WorkflowEditFormTriggerData;
    disabled?: boolean;
    handleConfigChange: (config: WorkflowEditFormTriggerData) => void;
};

export const WorkflowEditTriggerConfiguration: FC<WorkflowEditTriggerConfigurationProps> = ({
    workflow,
    trigger,
    disabled,
    handleConfigChange,
}) => {
    switch (trigger.type) {
        case "manual":
            return (
                // Manual triggers don't have any trigger-specific configuration (for now) so you only have to select the context
                <WorkflowEditCodeContext
                    context={trigger.context}
                    onChange={(context) => handleConfigChange({ ...trigger, context: context })}
                    disabled={disabled}
                />
            );
        case "time":
            return <div className="text-sm text-content-tertiary">Time-based triggers are coming soon.</div>;
        case "pullRequest":
            return (
                <WorkflowEditTriggerPullRequest
                    workflow={workflow}
                    trigger={trigger}
                    disabled={disabled}
                    handleConfigChange={(updatedTrigger) => handleConfigChange(updatedTrigger)}
                />
            );
        default:
            return null;
    }
};
